export default __webpack_public_path__ + "static/media/pealeap.003e25ce.svg";